var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"basebutton"},[_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"btn-icon"},[_c('MartzIcon',_vm._b({staticClass:"mainIcon"},'MartzIcon',_vm.$props,false)),_c('MartzIcon',{staticClass:"angleRight",attrs:{"icon":"angleRight","size":25,"color":"accent"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }